import React from 'react';
import { Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { getFullUrl } from 'utils/format';
import { ErrorPage } from 'components/errors';
import { LoadingPage } from 'components/loading';
import { StyledPaymentMethodForm } from './add-payment-method.style';

const getCopy = copyFor('settings.moving.addPaymentMethod');

interface Props {
  context: MovingStateMachineContext;
  matches: (state: string) => boolean;
  next: (...args: any[]) => any;
}

export const AddPaymentMethod = ({ matches, next, context }: Props) => {
  if (
    matches('addPaymentMethod.loadNewPlanAmountCents') ||
    matches('addPaymentMethod.createSetupIntent') ||
    matches('addPaymentMethod.fetchExistingPaymentMethodIds')
  )
    return <LoadingPage />;
  else if (
    matches('addPaymentMethod.loadingError') ||
    matches('addPaymentMethod.pollingError')
  )
    return <ErrorPage />;

  const description = getCopy('description', {
    utility: context.utility?.displayName,
  });

  return (
    <>
      <Text
        tag="h1"
        textStyle="heading800"
        margin={{ bottom: '16px', top: '33px' }}
      >
        {getCopy('title')}
      </Text>
      <Text>{description}</Text>
      <StyledPaymentMethodForm
        onSubmit={variables => next(variables)}
        stripeKey={process.env.ARCADIA_STRIPE_KEY || ''}
        loading={matches('addPaymentMethod.pollForPaymentCreation')}
        stripeClientSecret={context.stripeClientSecret || ''}
        // Using prop below to access new payment form but not actually allowing microdeposits
        allowMicrodeposits={true}
        redirectUrl={getFullUrl(routes().payment)}
      />
    </>
  );
};
